<script setup lang="ts">
const scrollToTop = () => {
  window.scrollTo(0, 0)
}
</script>
<template>
  <button
    id="back-to-top-btn"
    class="rounded-circle shadow"
    @click="scrollToTop()"
  >
    <img
      class="top-icon"
      style="
        width: 22px;
        transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
      "
      src="@/assets/image/icon/arrow_right.svg"
    />
  </button>
</template>

<style scoped>
#back-to-top-btn {
  position: fixed;
  bottom: 15px;
  float: right;
  right: 16px;
  z-index: 100;
  width: 44px;
  aspect-ratio: 1;
  font-size: 12px;
  border-color: #00000029;
  background-color: #ffffff;
  padding: 10px;
}

#back-to-top-btn i {
  width: 15px;
}
</style>
